import { call, put, select, takeLatest } from "redux-saga/effects";
import { linkAccount } from "../../lib/services";
import actiontypes from "../actions/actiontypes";
import {
    setManualLinkAccountFailure,
    setManualLinkAccountSuccess,
} from "../actions/loginactioncreators";
import getAuthToken from "../helpers/getAuthToken";
import getClientId from "../helpers/getClientId";
import { unknownErrorException } from "./handleError";
import getLocale from "../helpers/getLocale";

const genericManualLinkBackendErrors = [
    "internal server error",
    "request failed with status code",
    "unknown error",
    "unauthorized",
];

function resolveManualLinkErrorMessage(errorMessage) {
    if (!errorMessage || typeof errorMessage !== "string" || !errorMessage.trim()) {
        return unknownErrorException;
    }

    const lowerCased = errorMessage.trim().toLowerCase();
    if (genericManualLinkBackendErrors.some(pattern => lowerCased.includes(pattern))) {
        return unknownErrorException;
    }

    return errorMessage.trim();
}

export function* manualLinkAccountAsync(action) {
    const {clientId, username, password, accountNumber, itemKey } = action.payload;
    try {
        const authToken = yield select(getAuthToken);
        const locale = yield select(getLocale);

        const requestPayload = {
            clientId: clientId ?? (yield select(getClientId)),
            username,
            password,
            accountNumber,
        };

        const options = {
            headers: {
                Authorization: authToken,
                "Accept-Language": locale,
            },
        };

        const response = yield call(linkAccount, requestPayload, options);

        yield put(
            setManualLinkAccountSuccess({
                ...action.payload,
                response: response?.data,
            })
        );
    } catch (error) {
        let errorMessage;
        if (error?.response?.data) {
            errorMessage = typeof error.response.data === "string" ? error.response.data : undefined;
            errorMessage ??= typeof error.response.data.message === "string" ? error.response.data.message : undefined;
            errorMessage ??= typeof error.response.data.reasonMessage === "string" ? error.response.data.reasonMessage : undefined;
        }

        const linkError = resolveManualLinkErrorMessage(errorMessage);

        yield put(
            setManualLinkAccountFailure({
                itemKey,
                linkError,
            })
        );
    }
}

export function* watchManualLinkAccountAsync() {
    yield takeLatest(actiontypes.MANUAL_LINK_ACCOUNT, manualLinkAccountAsync);
}
